import PastWorkoutComponent from "components/TrainingChart/Body/WorkoutComponents/PastWorkoutComponent"
import FutureWorkoutComponent from "components/TrainingChart/Body/WorkoutComponents/FutureWorkoutComponent"

export default function TrainingChartWorkoutColumn({ 
    showWorkoutTemplate = true,
    trainingChartDataColumn,
    workoutTemplateKey,
    isPresent = false
}) {
    if (
        showWorkoutTemplate === false ||
        trainingChartDataColumn.trainingChartDataKey === 'empty'
    ) { 
        return null;
    }

    if (trainingChartDataColumn.trainingChartDataKey === 'past') {
        return (
            <div className="py-4 space-y-4">
                <PastWorkoutComponent
                    weekOfTheYearKey={trainingChartDataColumn.weekOfTheYearKey}
                    workoutTemplateKey={workoutTemplateKey}
                    overviewFileCompletionData={trainingChartDataColumn.overviewFile.completionData}
                    workoutCompletionData={trainingChartDataColumn.overviewFile.workoutTemplates[workoutTemplateKey]}
                    isPresent={isPresent}
                />
            </div>
        )
    }

    if (trainingChartDataColumn.trainingChartDataKey === 'active') {
        return (
            <div className="py-4 space-y-4">
                {trainingChartDataColumn.overviewFile.completionData[workoutTemplateKey].completed &&
                    <PastWorkoutComponent
                        weekOfTheYearKey={trainingChartDataColumn.weekOfTheYearKey}
                        workoutTemplateKey={workoutTemplateKey}
                        overviewFileCompletionData={trainingChartDataColumn.overviewFile.completionData}
                        workoutCompletionData={trainingChartDataColumn.overviewFile.workoutTemplates[workoutTemplateKey]}
                        isPresent={isPresent}
                    />
                }

                {!trainingChartDataColumn.overviewFile.completionData[workoutTemplateKey].completed &&
                    <FutureWorkoutComponent
                        weekOfTheYearKey={trainingChartDataColumn.weekOfTheYearKey}
                        workoutTemplateKey={workoutTemplateKey}
                        programTableColumn={trainingChartDataColumn.programTableColumn}
                        isPresent={isPresent}
                    />
                }
            </div>
        )
    }

    if (trainingChartDataColumn.trainingChartDataKey === 'future') {
        return (
            <div className="py-4 space-y-4">
                <FutureWorkoutComponent
                    weekOfTheYearKey={trainingChartDataColumn.weekOfTheYearKey}
                    workoutTemplateKey={workoutTemplateKey}
                    programTableColumn={trainingChartDataColumn.programTableColumn}
                    isPresent={isPresent}
                />
            </div>
        )
    }
}